import { Reducer } from 'redux';
import AppActionTypes from './types';
import { THEME, LANGUAGE } from 'types';
import { AppState } from './types';

export const initialState: AppState = {
  theme: THEME.BASE,
  language: LANGUAGE.EN
};

const reducer: Reducer<AppState> = (state = initialState, action: any) => {
  switch (action.type) {
    case AppActionTypes.SET_APP_THEME:
      return {
        ...state,
        theme: action.payload
      };
    case AppActionTypes.SET_APP_LANGUAGE:
      return {
        ...state,
        language: action.payload
      };
    case AppActionTypes.SET_HEADER_PANEL_EXPAND:
      return {
        ...state,
        headerPanelExpand: action.payload
      };
    case AppActionTypes.SET_PRIVATE_TEAMBASE_MAP: {
      const { privateTeamBaseMap } = state;
      return {
        ...state,
        privateTeamBaseMap: {
          ...privateTeamBaseMap,
          [action.payload.userId]: action.payload.baseMap
        }
      };
    }
    default:
      return state;
  }
};

export { reducer as AppReducer };
